module.exports = __webpack_public_path__ + "static/media/jeremy.191b9804.jpg";